const stateLabels = {
  upcoming: 'À venir',
  in_progress: 'En cours',
  completed: 'Terminé',
  rejected: 'Refusé',
  not_applicable: 'Non applicable'
};
const styles = {
  upcoming: 'border-slate-600 text-slate-300',
  in_progress: 'border-blue-400 bg-blue-500/10 text-blue-200',
  completed: 'border-emerald-500 bg-emerald-500/10 text-emerald-200',
  rejected: 'border-rose-400 bg-rose-500/10 text-rose-200',
  not_applicable: 'border-dashed border-slate-700 text-slate-400'
};
const date = value => value ? new Date(value).toLocaleString('fr-FR') : null;
export default function ApplicationPipeline({
  steps
}) {
  return <ol aria-label="Étapes du recrutement" className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4" data-testid="application-pipeline">
    {steps.map((step, index) => <li key={step.id} aria-current={step.state === 'in_progress' ? 'step' : undefined} className={`border-l-4 rounded-xl p-4 space-y-2 ${styles[step.state] || styles.upcoming}`}>
      <p className="text-xs">{index + 1} · {stateLabels[step.state] || step.state}</p>
      <h3 className="font-semibold text-sm">{step.name}</h3>
      <p className="text-xs">Responsable : {step.responsible || `${step.role} — à désigner`}</p>
      <p className="text-xs">Prochaine action : {step.next_action || (step.state === 'upcoming' ? 'Attendre l’étape précédente' : 'Aucune')}</p>
      {step.started_at && <p className="text-xs">Début : {date(step.started_at)}</p>}
      {step.completed_at && <p className="text-xs">Clôture : {date(step.completed_at)}</p>}
      {step.comment && <p className="text-xs break-words">{step.comment}</p>}
    </li>)}
  </ol>;
}
